import HeaderSkeleton, { getHeaderManifest } from '@carvana/header';
import { canvas } from '@carvana/helios-styles';
import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import classnames from 'classnames';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import '@carvana/header/styles.css';
import { isIOSWebView } from '../shared/nativeAppMessaging';

export const Container = styled.div`
  background-color: #e4ecf0;
  width: 100%;

  &.nativeMobile {
    height: max-content;
    opacity: 0;
    transition: opacity 0.2s ease-in;

    .content-loaded & {
      opacity: 1;
    }
  }
`;

export const Inner = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1800px;

  &.helios {
    background-color: ${canvas.default};
  }
`;

const chatContext = {
  contextType: 'carvana_trade'
};

const Header = ({ cookies }: { cookies: string }) => {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          'HeaderModule',
          [
            {
              component: 'default',
              default: {
                file: 'index.js',
                manifest: getHeaderManifest(process.env.CARVANA_APP_ENVIRONMENT)
              }
            }
          ]
        ]
      ]
    });
  }, []);

  const [nativeMobile, setNativeMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'object') {
      const isIOS = isIOSWebView();
      setNativeMobile(isIOS);
    }
  }, []);

  return (
    <Container className={classnames({ nativeMobile })}>
      <Inner>
        <MfeReactComponent
          component="default"
          module="HeaderModule"
          environment={process.env.CARVANA_APP_ENVIRONMENT}
          loading={<HeaderSkeleton cookies={cookies} />}
          useProvider
          shouldShowCovid19Banner={false}
          chatContext={chatContext}
        />
      </Inner>
    </Container>
  );
};

export default Header;
